import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';

const TabTwelve = ({
  eventManagementData,
  setEventManagementData,
  onClickAll,
  isEdit = false
}) => {
  // Add safety check for undefined data
  if (!eventManagementData || !Array.isArray(eventManagementData)) {
    return (
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Event Management
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography>Loading...</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Event Management
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="event-management-form-all"
            control={
              <Checkbox
                id="event-management-all"
                checked={eventManagementData.length > 0 && eventManagementData.every((item) => item.value)}
                onClick={(e) =>
                  onClickAll(eventManagementData, 'common', setEventManagementData, e)
                }
                disabled={isEdit}
              />
            }
            label="All"
          />
        </Grid>
        {eventManagementData.map((data, index) => {
          return (
            <Grid item xs={6} key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={eventManagementData[index]?.value || false}
                    onChange={(e) => {
                      let items = [...eventManagementData];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setEventManagementData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default TabTwelve;